// Store functionality
import actions from './actions'
import mutations from './mutations'
import state from './state'

export default {
  state: state,
  mutations: mutations,
  actions: actions,
}
